import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface PasswordConfirmationDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: (password: string) => void;
  onCancel: () => void;
}

export const PasswordConfirmationDialog: React.FC<PasswordConfirmationDialogProps> = ({
  open,
  title = "Confirm Password",
  message = "Please enter your password to confirm this action:",
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    onConfirm(password);
    setPassword("");
    setError(false);
  };

  const handleCancel = () => {
    onCancel();
    setPassword("");
    setError(false);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="password-dialog-title"
      aria-describedby="password-dialog-description"
    >
      <DialogTitle id="password-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="password-dialog-description">
          {message}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(false);
          }}
          onKeyPress={handleKeyPress}
          error={error}
          helperText={error ? "Incorrect password" : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {cancelButtonText}
        </Button>
        <Button onClick={handleConfirm} color="error" autoFocus>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordConfirmationDialog;

